<template>
	<div class="roles">
		<ul class="roles__list">
			<li class="roles__item" v-for="(role, index) in items" :key="index">
				<RoleCard
					:role="role"
					:id="`${uid}_${index}_card`"
					@remove-rol="showModalRemoveRole"
				/>
			</li>
		</ul>
		<Modals
			v-model="showModal"
			type="confirmation"
			:title="confimationTitle"
			labelConfirmButton="Yes, remove the role"
			labelCancelButton="Cancel"
			@confirm="removeRole"
			@cancel="cancel"
		/>
	</div>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import RoleCard from './roles-card';
import { mapActions } from 'vuex';

export default {
	name: 'RolesList',
	components: {
		RoleCard,
		Modals
	},
	props: {
		items: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			role: {},
			showModal: false,
			confimationTitle: ''
		};
	},
	computed: {
		loadingSource() {
			let loading = this.$store.getters['loader/loading'](
				'get.supportroles'
			);
			return loading;
		},
		loadingOtherSources() {
			let loading = this.$store.getters['loader/loading'](
				`delete.supportroles.${this.role.roleId}`
			);
			return loading;
		}
	},
	methods: {
		...mapActions('roles', { removeRoleAction: 'removeRole' }),
		showModalRemoveRole(role) {
			this.role = role;
			this.confimationTitle = `Are you sure you want to remove the "${role.role}" role?`;
			this.showModal = true;
		},
		async removeRole() {
			try {
				await this.removeRoleAction(this.role.roleId).then(() => {
					this.$store.dispatch('roles/reloadRoles');
				});
			} finally {
				this.showModal = false;
			}
		},
		cancel() {
			this.role = {};
			this.showModal = false;
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Roles Results List
    * Can use SCSS variables = TRUE
	* [Table of Contents]
    *
    * BASE
    * BASE DESKTOP-UP
*/

/*------------------------------------*\
  #BASE
\*------------------------------------*/
::v-deep .modal__body {
	overflow: initial;
}
.roles {
	&__list {
		display: grid;
		grid-template-columns: 1fr;
		gap: $gutter-lg;

		@include mq($from: md-l) {
			grid-template-columns: 1fr 1fr;
		}
	}
}
</style>
